import { render } from "./AddLiveDataPosition.vue?vue&type=template&id=c9d8a2d0"
import script from "./AddLiveDataPosition.vue?vue&type=script&lang=js"
export * from "./AddLiveDataPosition.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__